var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 10,
    fill: "url(#paint0_linear_306_254)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.7891 75.1172C97.2184 75.1172 111.348 60.9879 111.348 43.5586C111.348 26.1293 97.2184 12 79.7891 12C62.3597 12 48.2305 26.1293 48.2305 43.5586C48.2305 60.9879 62.3597 75.1172 79.7891 75.1172Z",
    fill: "url(#paint1_radial_306_254)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.575 124.406C121.514 139.083 101.718 148.222 79.7874 148.222C57.8572 148.222 38.0608 139.083 24 124.406C31.9405 101.228 53.9187 84.5669 79.7874 84.5669C105.656 84.5669 127.634 101.228 135.575 124.406Z",
    fill: "url(#paint2_radial_306_254)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_254",
    x1: 0,
    y1: 0,
    x2: 160,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BDA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9485"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_306_254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.4832 32.4422) scale(46.2305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_306_254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.8725 105.183) scale(64.9322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#D1D1D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user_default.491daf27d0e12f03a20d6d0108b022dd.svg";
export { ForwardRef as ReactComponent };